<template>
  <div class="main-block">
    <div class="table -users-group-table-">
      <div class="table__header">
        <div class="table__header-inner">
          <p class="table__title">Список групп</p>
          <div v-if="$permissionsCreate" class="table__buttons">
            <Button class="-s-" @click="openCreateFolder">Добавить папку</Button>
          </div>
        </div>
      </div>
      <div class="table__body">
        <div class="table__nav">
          <ul class="table__nav-list">
            <li class="table__col">
              <p class="table__col-title">Название</p>
            </li>
            <li class="table__col">
              <p class="table__col-title">Участников</p>
            </li>
            <li class="table__col">
              <p class="table__col-title">&nbsp;</p>
            </li>
          </ul>
        </div>
        <div class="table__content">
          <template v-if="!isLoadGroup">
            <TableRow
              v-for="(folder, idx) in folders"
              :key="'folder' + idx"
              :padding-left="30"
              :data="folder"
            ></TableRow>
          </template>
          <template v-else>
            <SkeletRow v-for="i in 5" :key="i"></SkeletRow>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from './components/Row';
import SkeletRow from './components/SkeletRow';
import { mapState, mapActions } from 'vuex';

export default {
  components: { TableRow, SkeletRow },
  computed: {
    ...mapState('usersGroups', {
      folders: s => s.data.folders,
      isLoadGroup: s => s.meta.isLoadGroup
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userGroupModuleAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    optionsFields() {
      const arr = [];

      if (this.$permissionsUpdate) {
        arr.push(this.options[0]);
      }

      if (this.$permissionsCreate) {
        arr.push(this.options[1]);
      }

      if (this.$permissionsDelete) {
        arr.push(this.options[2]);
      }

      return arr;
    }
  },
  methods: {
    ...mapActions('usersGroups', ['getCourse', 'setAsideMeta', 'setAsideData']),
    openCreateFolder() {
      this.setAsideData({
        path: 'folder',
        value: {
          name: '',
          parentId: ''
        }
      });
      this.setAsideMeta({ path: 'isOpen', value: true });
    }
  }
};
</script>
